import axios from 'axios';
import API from '../config/API';

export const receiptService = {
    sendReceiptEmail
};

function sendReceiptEmail(params) {
    let accessToken = localStorage.getItem('accessToken');
    
    return axios.post(API.SEND_RECEIPT_EMAIL, params, {
        headers: {
            'Content-Type': 'application/json',
            'authorization': "Basic YmV1YXBwOmJldWFwcA==",
            'accessToken': accessToken
        }
    });
}